import { render, staticRenderFns } from "./DownloadApp.vue?vue&type=template&id=1329da5f&scoped=true&lang=pug&"
import script from "./DownloadApp.vue?vue&type=script&lang=ts&"
export * from "./DownloadApp.vue?vue&type=script&lang=ts&"
import style0 from "./DownloadApp.vue?vue&type=style&index=0&id=1329da5f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1329da5f",
  null
  
)

export default component.exports